var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: {
        margin: "auto",
        "background-image": "none",
        display: "block",
        "shape-rendering": "auto",
      },
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "64px",
        height: "400px",
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
      },
    },
    [
      _c(
        "circle",
        { attrs: { cx: "50", cy: "20", r: "10", fill: "#00b1ac" } },
        [
          _c("animate", {
            attrs: {
              attributeName: "cy",
              dur: "1s",
              repeatCount: "indefinite",
              calcMode: "spline",
              keySplines: "0.45 0 0.9 0.55;0 0.45 0.55 0.9",
              keyTimes: "0;0.5;1",
              values: "20;80;20",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }